export default __webpack_public_path__ + "static/dev-nebraska-6eaed0eea99120d23aa3f89dee5bc6ad.jpg";